"use client";

import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";

const IS_LOCALHOST =
    typeof window !== "undefined" &&
    ["localhost", "127.0.0.1"].includes(window.location.hostname);

function getCookieDomain(hostname: string) {
    if (IS_LOCALHOST) return hostname;
    const parts = hostname.split(".");
    if (parts.length < 2) return hostname;
    return `.${parts.slice(-2).join(".")}`;
}

export function initAmplify() {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: process.env.NEXT_PUBLIC_USER_POOL_ID,
                userPoolClientId: process.env.NEXT_PUBLIC_USER_POOL_CLIENT_ID,
                loginWith: {
                    email: true,
                    oauth: {
                        providers: ["Google"],
                        domain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN,
                        redirectSignIn: [process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN_URL],
                        redirectSignOut: [process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT_URL],
                        responseType: "code",
                        scopes: [
                            "email",
                            "openid",
                            "profile",
                        ],
                    },
                },
                signUpVerificationMethod: "code",
            },
        },
    });

    cognitoUserPoolsTokenProvider.setKeyValueStorage(
        new CookieStorage({
            domain:
                typeof window !== "undefined"
                    ? getCookieDomain(window.location.hostname)
                    : undefined,
            secure: !IS_LOCALHOST,
            path: "/",
            sameSite: "strict",
            expires: 365,
        })
    );
}
